<script>
import Base from "@/components/RequestDetailsForDefaultVue/RequestAttachments.vue";

export default {
  name: "CustomerServiceFilesRequestAttachments",
  extends: Base,
};
</script>
